import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import Edit from './Edit'
import styles from './style.module.less'
import { Link } from 'react-router'
import { isSiYiTeam } from '@util'

export default class extends Component {
  render() {
    const header = [
      '团队管理',
      <Link
        to={
          isSiYiTeam()
            ? '/localMerchant/siYiTeamGroupMember'
            : '/localMerchant/groupMember'
        }
      >
        团队成员
      </Link>,
      '创建成员'
    ]

    return (
      <HeaderView header={header} title="创建成员">
        <div className={styles.wrap}>
          <Edit {...this.props} />
        </div>
      </HeaderView>
    )
  }
}
